import React, { useState } from "react";
import { StyleSheet, View, ScrollView, Alert } from "react-native";
import {
  Text,
  Provider as PaperProvider,
  DefaultTheme,
  TextInput,
} from "react-native-paper";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import routes from "../../routing/routes";
import {
  blackColor,
  whiteColor,
  removeAccountColor,
  redBorderInputColor,
  redBackgroundColor,
} from "../../common/colors";
// import { Avatar } from "react-native-paper";
import Button from "../../common/Button";
import { Platform } from "react-native";
import Error from "../../common/Error";
import ErrorPasswordLength from "../../common/Error/ErrorPasswordLength";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import checker from "../../common/helpers/checker";
import displayName from "../../common/displayName";
import PageContainer from "../../common/PageContainer";
import { Dimensions } from "react-native";
import MAX_WIDTH from '../../common/MaxWidth';
import t, {tSaga} from "../../translations";

const inputPadding = 12;

const EditProfilePage = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const [password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const back = () => props.navigation.navigate(routes.Settings);

  const goToSignOut = () => {
    props.navigation.navigate(routes.SignOut);
  };

  React.useEffect(() => {
    if (props.error) {
      props.saveErrorReponse(null);
    }
    return () => {
      props.saveErrorReponse(null);
    };
  }, []);

  const modalAreYouSure = () => {
    if (Platform.OS === "web") {
      if (
        confirm(tSaga('editProfilePage_deleteAccount_message', props.language)) ==
        true
      ) {
        props.deleteProfile({ redirect: goToSignOut });
      }
    } else {
      Alert.alert(
        tSaga('editProfilePage_deleteAccount_else_message_one', props.language),
        tSaga('editProfilePage_deleteAccount_else_message_two'),
        [
          {
            text: tSaga('editProfilePage_deleteAccount_choices_no', props.language),
            onPress: () => {},
            style: "cancel",
          },
          {
            text: tSaga('editProfilePage_deleteAccount_choices_yes', props.language),
            onPress: () => {
              props.deleteProfile({ redirect: goToSignOut });
            },
          },
        ]
      );
    }
  };

  const isWrongPassword =
    props.errorCode === "auth/wrong-password" ||
    props.errorCode === "auth/too-many-requests";
  const isInvalidPassword =
    props.errorCode === "auth/weak-password" ||
    props.errorCode === "auth/different-passwords";
  const isNotWrongPassword =
    !isWrongPassword && !isInvalidPassword && props.error;

    const win = Dimensions.get("window");

  
  return (
    <PageContainer
      {...props}
      isCloseIcon={true}
      noBackground={true}
      backRoute={routes.Settings}
      maxWidth={MAX_WIDTH.AUTHENTICATION}
    >
      <View style={styles.container}>
        <View style={styles.editProfileContainer}>
          <View style={styles.editProfile}>
            <Text style={styles.settings}>
              {t('editProfilePage_editProfile_title')}
            </Text>
          </View>
        </View>

        {/* <View style={styles.avatar}>
              <Avatar.Text size={100} label="XD" color="cyan" />
              <View style={styles.userNameAndEmailContainer}>
                  <Text style={styles.editProfile}>Zmień Avatar</Text>
                </View>
            </View> */}
        <View style={styles.inputsContainer}>
          <TextInput
            mode="outlined"
            label={displayName(props?.user)}
            placeholder=""
            disabled={true}
            style={{ 
              ...styles.inputDisabledFirst, 
              ...styles.input,
              width: "100%", 
            }}
            returnKeyType="done"
            // right={<TextInput.Icon name="pencil-outline" />}
          />
          <TextInput
            mode="outlined"
            label={props?.user?.user.email}
            placeholder=""
            disabled={true}
            style={{
              ...styles.inputDisabledSecond,   
              ...styles.input,
              width: "100%", 
            }}
            returnKeyType="done"
            // right={<TextInput.Icon name="pencil-outline" />}
          />
            <View style={styles.changePasswordContent}>
              <Text style={styles.changePassword}>
                {t('editProfilePage_editProfile_change_password')}
              </Text>
            </View>
          <TextInput
            mode="outlined"
            label={t('editProfilePage_editProfile_old_password')}
            placeholder=""
            value={oldPassword}
            secureTextEntry={true}
            onChangeText={(text) => {
              setOldPassword(text);
              isWrongPassword && props.saveErrorReponse(null);
            }}
            error={isWrongPassword && {...styles.inputBorderError,     width: "100%", }}
            style={
              isWrongPassword ? {
                ...styles.inputError,  
                width: "100%", 
              } : {
                ...styles.inputOldPassword, 
                ...styles.input, 
                width: "100%", 
              }
            }
            returnKeyType="done"
            // right={<TextInput.Icon name="" />}
          />
           {isWrongPassword && <Error error={props.error} />} 
          <TextInput
            mode="outlined"
            label={t('editProfilePage_editProfile_new_password')}
            placeholder=""
            value={password}
            secureTextEntry={true}
            onChangeText={(text) => {
              setPassword(text);
              isInvalidPassword && props.saveErrorReponse(null);
            }}
            error={isInvalidPassword && {
              ...styles.inputBorderError,  
              width: "100%", 
            }}
            style={
              isInvalidPassword ? 
              {
                ...styles.inputError,  
                width: "100%", 
              } :
               {
                 ...styles.inputNewPassword, 
                 ...styles.input,
                 width: "100%", 
                }
            }
            returnKeyType="done"
            // right={<TextInput.Icon name="" />}
          />
          {isInvalidPassword && <ErrorPasswordLength error={props.error} />} 
          <TextInput
            mode="outlined"
            label={t('editProfilePage_editProfile_repeat_new_password')}
            value={passwordRepeat}
            secureTextEntry={true}
            onChangeText={(text) => {
              setPasswordRepeat(text);
              isInvalidPassword && props.saveErrorReponse(null);
            }}
            placeholder=""
            error={isInvalidPassword && {...styles.inputBorderError,     width: "100%", }}
            style={
              isInvalidPassword
                ? {
                  ...styles.inputError,  
                  width: "100%", 
                }
                : {
                  ...styles.inputRepeatNewPassword,  
                  ...styles.input,
                  width: "100%", 
                }
            }
            returnKeyType="go"
            // onSubmitEditing={props.savePassword({
            //   password,
            //   oldPassword,
            // })}
            // right={<TextInput.Icon name="" />}
          />
          {isInvalidPassword && <ErrorPasswordLength error={props.error} />} 
          <View style={styles.clickToLogOut}>
            <Button
              disabled={
                !(passwordRepeat === password && !!password && !!oldPassword)
              }
              onPress={() => props.savePassword({ password, oldPassword })}
              value={t('editProfilePage_editProfile_save_changes_button')}
            />
          </View>
        </View>
        <View style={styles.removeContainer}>
          <View style={styles.removeAccountContent}>
            <Text
              style={styles.removeAccount}
              onPress={() => modalAreYouSure()}
            >
             {t('editProfilePage_editProfile_remove_account_button')}
            </Text>
          </View>
        </View>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  const language = state.language;
  const errorMessage = state.errorMessages && checker(state.errorMessages.code);
  const errorCode = state.errorMessages ? state.errorMessages.code : "";

  return { error: errorMessage, errorCode, user, language };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...actionCreatorsForgotPassword,
})(EditProfilePage);




const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 10,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  container: {
    alignItems: "center",
  },
  settingsContainer: {
    alignItems: "flex-start",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
  },
  editProfileContainer: {
    alignSelf: 'flex-start',
  },
  editProfile: {
    justifyContent: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    alignContent: "flex-start",
    alignSelf: "flex-start",
  },
  settings: {
    fontSize: 24,
    lineHeight: 26,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
  },
  containerButtons: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  icons: {
    alignItems: "flex-end",
    marginTop: 30,
    marginRight: 20,
    width: 380,
  },
  avatar: {
    top: 20,
  },
  // paddingLeft: 38,
  userNameAndEmailContainer: {
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    alignContent: "space-around",
  },
  userName: {
    paddingLeft: 22,
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "700",
    textTransform: "uppercase",
  },
  userEmail: {
    paddingTop: 10,
    paddingLeft: 22,
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "400",
    textTransform: "none",
  },
  input:{
    backgroundColor: whiteColor,
    height: 42,
  },
  inputDisabledFirst: {
    paddingTop: 24,
    paddingBottom: 18,
  },
  inputDisabledSecond: {
    paddingTop: 0,
    height: 42,
  },
  inputOldPassword: {
    paddingTop: 0,
    paddingBottom: 18,
  },
  inputNewPassword: {
    paddingTop: 0,
    paddingBottom: 10,
  },
  inputRepeatNewPassword: {
    paddingTop: 0,
    paddingBottom: 16,
  },
  inputsContainer: {
    alignItems: "flex-start",
    display: "flex",
    paddingTop: 20,
    width: "100%",
  },
  breakline: {
    margin: 8,
  },
  breaklinePassword: {
    margin: 8,
  },
  breaklineNewPassword: {
    margin: 6,
  },
  removeAccount: {
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0.5,
    fontWeight: "400",
    color: removeAccountColor,
    textTransform: "uppercase",
  },
  removeContainer: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    marginTop: 50,
  },
  removeAccountContent: {
    width: "100%",
    marginBottom: 40,
  },
  changePassword: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
  },
  changePasswordContent: {
    alignItems: "flex-start",
    paddingBottom: 18,
    marginTop: 30, 
  },
  clickToLogOut: {
    alignItems: "center",
    alignSelf: "center",
    position: "relative",
    top: 50,
    marginBottom: 50,
    left: 0,
    right: 0,
    width: "100%",
  },
  inputBorderError: {
    borderColor: redBorderInputColor,
    borderWidth: 1,
    borderStyle: "solid",
  },
  inputError: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 42,
  },
});
